(async() => {
    const { Core } = await importModule('Core');
  
    const {
        arrEq,
        $JSON,
        cache,
        fetchHTML
    } = await importModule('Utils');
 
 
    const strEsc = (str) => str.replace(/["\\]/g, '\\$&');
 
    const CN_UNAVAILABLE = '!unavailable';
    const ATTR_UNAVAILABLE = 'data-unavailable';
    const ATTR_OPTION_INDEX = 'data-option-index'; 
    const ATTR_VARIANT_ID = 'variant-id'; 
    const ATTR_PICKER_TYPE = 'picker-type';
    const ATTR_SELLING_PLAN_ID = 'selling-plan-id';
    const ATTR_PRODUCT_URL = 'product-url';
 
    customElements.define('product-variant-selector', class extends Core {
        
        elements = {
            variantsJSON: '[data-variants-json]',
            optionsJSON: '[data-options-json]',
            displayValues: '*[data-display-value]',
            selectors: '*[data-option-selector]',
            variantIdInput: 'input[name="id"]'
        }
 
        subscriptions = {
            'selling-plan:change': '_onSellingPlanChange'
        }
        
        render() {
            this.optionsMap = {};
            this.options = $JSON(this.$optionsJSON);
            this.variants = $JSON(this.$variantsJSON);
            this._handleSellingPlanChange();
            this._getDefaultVariant();
            this._linkOptionSelectors();
            this._initCache();
            this._handleOptionChange();
            this.$variantIdInput.disabled = false;
 
 
        
          if(this.querySelector('[data-option-value]:checked')) {
         
             this.querySelector('[data-option-value]:checked').dispatchEvent(new Event('change', { bubbles: true }));
          } else {
            if(this.querySelector('[data-option-value]')) {
             
               this.querySelector('[data-option-value]').dispatchEvent(new Event('change', { bubbles: true }));
            }
          }         
        }
 
       _arrayIncludes(e, t) {
          for (var n = 0; n < e.length; n++)
            if (e[n] == t) return !0;
          return !1
        } 
        _uniq(e) {
          for (var t = [], n = 0; n < e.length; n++) this._arrayIncludes(t, e[n]) || t.push(e[n]);
          return t
        }
 
      _linkOptionSelectors() {
        // Building our mapping object.
        
        for (var i=0; i< this.variants.length; i++) {
          var variant = this.variants[i];
          if (variant.available) {
            // Gathering values for the 1st drop-down.
            this.optionsMap['root'] = this.optionsMap['root'] || [];
            this.optionsMap['root'].push(variant.option1);
            this.optionsMap['root'] = this._uniq(this.optionsMap['root']);
            // Gathering values for the 2nd drop-down.
            if (this.options.length > 1) {
              var key = variant.option1;
              this.optionsMap[key] = this.optionsMap[key] || [];
              this.optionsMap[key].push(variant.option2);
              this.optionsMap[key] = this._uniq(this.optionsMap[key]);
            }
            // Gathering values for the 3rd drop-down.
            if ( this.options.length === 3) {
              var key = variant.option1 + ' / ' + variant.option2;
              this.optionsMap[key] = this.optionsMap[key] || [];
              this.optionsMap[key].push(variant.option3);
              this.optionsMap[key] = this._uniq(this.optionsMap[key]);
            }
          }
        }
      };
 
        _handleSellingPlanChange() {
            if (this.hasAttribute(ATTR_SELLING_PLAN_ID)) {
                this.sellingPlanId = this.getAttribute(ATTR_SELLING_PLAN_ID)
                this.subscribe('selling-plan:change');
            }
        }
 
        _handleOptionChange() {
            this._setOptionsAvailability();
            this.addEventListener('change', this._optionChangeHandler.bind(this));    
        }
        
        _getDefaultVariant() {
            this.variant = this.variants.find(({ id }) => id === +this.getAttribute(ATTR_VARIANT_ID));            
        }
 
        _initCache() {
            cache.set(`${this.variant.id}${this.sellingPlanId}`, this.getParentSection()?.cloneNode(true));
        }
 
        _setOptionsAvailability() {
            this.options
                .reduce(this._getOptionsState.bind(this), [...new Set()])
                .map(this._toggleOptionAviability.bind(this));
             this._checkUnavailable();
        }
 
       _checkUnavailable(valueIndex) {
        this.options.map((option, i) => {
          let optionsToCheck = [...this.variant.options];
          let needed_array = [];
          
          if(i==0){
            needed_array = this.optionsMap['root'];
          }else if(i==1){
            const options_string = optionsToCheck[0];
            needed_array = this.optionsMap[options_string];
          }else if(i==2){
            const options_string = optionsToCheck[0] + " / " +optionsToCheck[1];
            needed_array = this.optionsMap[options_string];
          }
         
            option.values.map(optionValue => {
            optionsToCheck[i] = optionValue;
   
              if(typeof needed_array != "undefined"){
               const matchLinked = needed_array.indexOf(optionValue) + 1;
              this._toggleOptionHide(option.name, optionValue, !matchLinked);   
              }else{
               this._toggleOptionHide(option.name, optionValue, true);   
              }           
            
          })        
        })

          let variant_optionsToCheck = [...this.variant.options];

          variant_optionsToCheck.map(optionValue => {
            var input = this.querySelector("[value='"+optionValue+"']");
            if(input){
              var label = input.closest("label");
              if(label.hasAttribute("data-soldout")){         
                var  first_label = label.closest("div").querySelector("label:not([data-soldout])"); 
                if(first_label){
                  first_label.querySelector("input").checked = true;
                  first_label.querySelector("input").dispatchEvent(new Event('change', { bubbles: true }));
                }
              }
            }

          });
         

         
      };
 
        _optionChangeHandler(e) {
            if(!(e instanceof CustomEvent)) {
                this._updateVariantWithOption(e.target);
                this._setOptionsAvailability();
                this._publishVariantDoc();
            }
            this._updateDisplayValue(e.target);
            this.$variantIdInput.value = this.variant.id;
 
        }
 
        _onSellingPlanChange({ sellingPlanId }) {
            this.sellingPlanId = sellingPlanId;
            this._publishVariantDoc();
        }
 
        _updateDisplayValue(target) {
            if(!this.$displayValues.length) return;
            const match = this.$displayValues.find(item => item.getAttribute(ATTR_OPTION_INDEX) === target.getAttribute(ATTR_OPTION_INDEX));
            if(match) match.innerText = target.value;
        }
 
        async _publishVariantDoc() {
                   
            this.publish('variant:change', {
                doc: cache.get(`${this.variant.id}${this.sellingPlanId}`) || await this._fetchVariantDOM(),
                variantId: this.variant.id,
                stock: this.variant.available,
                variantImagePosition: this.variant.featured_media?.position,
                sellingPlanId: this.sellingPlanId
            });
        }
 
        async _fetchVariantDOM() {
            this.publish('variant:loading', true);
            const doc = await fetchHTML(this.requestURL);
            this.publish('variant:loading', false);
            cache.set(`${this.variant.id}${this.sellingPlanId}`, doc);
            return doc;
        }
 
        _updateVariantWithOption(target) {
            const index = +target.getAttribute(ATTR_OPTION_INDEX);
            this.variant = 
                this._getVariantFromValue(target.value, index) || 
                this._getFirstAvailableVariant(target.value, index);
        }
 
        _getVariantFromValue(setValue, i) {
            let newOptions = [...this.variant.options];
            newOptions[i] = setValue;
            return this.variants.find(({ options }) => arrEq(options, newOptions));
        }
        
        _getFirstAvailableVariant(value, index) {
            const match = this.variants.find(variant => variant.options[index] === value);
            this._selectVariantOptions(match, index);
            return match;
        }
 
        _selectVariantOptions(src, ignore) {
            src.options.map((value, i) => {
                if(i !== ignore) {
                    const input = this._getInputEl(value, i);
                    input.checked = true;
                    input.dispatchEvent(new CustomEvent('change', {
                        bubbles: true,
                        cancelable: true
                    }));
                }
            })
        }
 
        _getOptionsState(acc, option, i) {
            option.values.map(value => {
                acc.push({
                    value,
                    index: i,
                    hasVariant: !!this._getVariantFromValue(value, i)
                });
            })
            return acc;
        }
 
        _getInputEl(value, index) {
            return this.querySelector(`[value="${value.replace(/["\\]/g, '\\$&')}"][${ATTR_OPTION_INDEX}="${index}"]`)
        }
 
        _toggleOptionAviability({ value, index, hasVariant }) {
            this._getInputEl(value, index)
                .classList.toggle(CN_UNAVAILABLE, !hasVariant)
                // .toggleAttribute(ATTR_UNAVAILABLE, !hasVariant);
        }
 
 
      	  _toggleOptionHide(name, value, disable) {
        const targetInput = this.querySelector(`[name="${strEsc(name)}"][value="${strEsc(value)}"`);
        if(targetInput){
        disable
          ? targetInput.closest("[data-swatch-field]").setAttribute('data-soldout', '')
          : targetInput.closest("[data-swatch-field]").removeAttribute('data-soldout');
        }
      };	
 
        get requestURL() {
            const params = new URLSearchParams({ 
                'selling_plan': this.sellingPlanId || '', 
                'variant': this.variant.id,
                'section_id': this.sectionId
            });
            return `${this.productURL}?${params.toString()}`;
        }
 
        get productURL() {
            return this.getAttribute(ATTR_PRODUCT_URL);
        }
 
    });
})()